    var emblaNode = document.querySelector('.js-slider');
    var embla = EmblaCarousel(emblaNode);

    setInterval(function() {
      embla.scrollNext();
    }, 3000); // Přepínat každé 3 sekundy

    var dotsContainer = document.querySelector('.js-slider__dots');

    function createDot(index) {
      var dot = document.createElement('span');
      dot.classList.add('slider-dots__dot');
      dot.addEventListener('click', function() {
        embla.scrollTo(index);
      });
      return dot;
    }

    for (var i = 0; i < embla.slideNodes().length; i++) {
      dotsContainer.appendChild(createDot(i));
    }

    function updateDots() {
      var dots = dotsContainer.querySelectorAll('.slider-dots__dot');
      var selectedIndex = embla.selectedScrollSnap();
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.remove('slider-dots__dot--active');
      }
      dots[selectedIndex].classList.add('slider-dots__dot--active');
    }

    embla.on('select', updateDots);    